import React from 'react';
import { AlertDialog } from '@lumx/react';
import { OUNode, Site } from '../../types';

interface Props {
  node: OUNode | null;
  allNodes: OUNode[];
  allSites: Site[];
  onConfirm: () => void;
  onCancel: () => void;
}

function countDescendants(id: string, allNodes: OUNode[]): number {
  const direct = allNodes.filter(n => n.parentId === id);
  return direct.reduce((sum, n) => sum + 1 + countDescendants(n.id, allNodes), 0);
}

const DeleteNodeDialog: React.FC<Props> = ({ node, allNodes, allSites, onConfirm, onCancel }) => {
  if (!node) return null;

  const typeName = node.type === 'Location' ? 'location' : 'org unit';
  const descendantCount = countDescendants(node.id, allNodes);
  const assignedSite = allSites.find(s => s.assignedNodeId === node.id);

  return (
    <AlertDialog
      isOpen
      onClose={onCancel}
      kind="error"
      title={`Delete ${node.name}?`}
      confirmProps={{ label: 'Delete org unit', onClick: onConfirm }}
      cancelProps={{ label: 'Cancel', onClick: onCancel }}
    >
      <div style={{ fontSize: 14, color: 'var(--color-dark-l1)', lineHeight: 1.6 }}>
        {descendantCount > 0 ? (
          <p>
            This {typeName} has <strong>{descendantCount} sub-unit{descendantCount !== 1 ? 's' : ''}</strong>.
            {' '}Deleting it will also permanently delete all sub-units. This action cannot be undone.
          </p>
        ) : (
          <p>
            This {typeName} will be permanently deleted. This action cannot be undone.
          </p>
        )}
        {assignedSite && (
          <p style={{ marginTop: 10 }}>
            <strong>{assignedSite.name}</strong> is currently mapped here and will become unmapped.
          </p>
        )}
      </div>
    </AlertDialog>
  );
};

export default DeleteNodeDialog;
